import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


const deleteClinicFile = async (fileId: string): Promise<void> => {
  await api.delete(`clinic/files/${fileId}`);
};

export const useDeleteClinicFile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: deleteClinicFile,
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "delete-file-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.files(),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Clinic File]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.files(),
      });

      handleErrors(res, "mutation");
    },
  });
};
